<template>
  <router-link :to="{ name: 'register' }"><i class="pe-7s-add-user"></i></router-link>
</template>
<script>
export default {
  name: 'Register',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  },
  mounted () {
  }
}
</script>
